// cardTypes — shared metadata for the four kid pet cards. Single
// source of truth for label / emoji / tint / blurb across:
//   • SendCards.jsx       (parent-side grant sheet)
//   • KidCardDeck.jsx     (kid-side spend deck)
//   • CardRevealOverlay.jsx (full-screen reveal animation)
//
// Adding a fifth card type? Update KID_CARD_TYPES here, the check
// constraint in migration 0239 (kid_card_grants.card_type), and the
// case-when columns in grant_kid_cards / claim_kid_card_grant /
// spend_kid_card RPCs (0238 + 0239).
//
// EMOJI-IN-UI EXCEPTION: this tree (src/experiments/kids-mode/**)
// is the explicit opt-in to emojis per the plan.

// Five card types. Boost → AGI, Water → mana refill (added as a
// fifth card via migration 0248). Order matters: it's the render
// order in SendCards' grant grid and the kid's KidCardDeck.
export const KID_CARD_TYPES = [
  { key: "super", label: "Super", emoji: "🥦", tint: "#2F8F83", blurb: "Veggies + greens" },
  { key: "build", label: "Build", emoji: "💪", tint: "#D96B2B", blurb: "Protein" },
  { key: "boost", label: "Boost", emoji: "⚡", tint: "#D4A637", blurb: "Grains + energy" },
  { key: "spark", label: "Spark", emoji: "✨", tint: "#7A4E2D", blurb: "Spices + treats" },
  { key: "water", label: "Water", emoji: "💧", tint: "#5DA9E9", blurb: "Refills mana" },
  // DB key stays 'dairy' (the source food theme); kid-facing label
  // is "Protect" because it grants the DEF stat. Blurb still tells
  // the parent what foods qualify.
  { key: "dairy", label: "Protect", emoji: "🛡️", tint: "#C8A86A", blurb: "Calcium + dairy" },
];

export const KID_CARD_BY_KEY = Object.fromEntries(
  KID_CARD_TYPES.map((c) => [c.key, c]),
);
